var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDsUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#FBCB28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2743 25.4301L29.9349 25.893L30.44 26.1657C33.5093 27.8231 35.5 31.0444 35.5 34.5644C35.5 35.3528 34.8528 36 34.0644 36H17.9354C17.147 36 16.5 35.3529 16.5 34.5644C16.5 31.0105 18.492 27.7919 21.5568 26.1675L22.068 25.8966L21.7259 25.43C21.075 24.5425 20.6935 23.4836 20.6935 22.3064C20.6935 19.389 23.0825 17 26 17C28.9175 17 31.3065 19.389 31.3065 22.3064C31.3065 23.4839 30.9249 24.5427 30.2743 25.4301ZM23.087 26.7315L22.8582 26.5762L22.6051 26.6875C19.4916 28.0561 17.4354 31.1367 17.4354 34.5645V35.0645H17.9354H34.0644H34.5644V34.5645C34.5644 31.1368 32.5082 28.0562 29.3947 26.6875L29.1415 26.5762L28.9127 26.7315C28.0919 27.2885 27.0926 27.613 25.9999 27.613C24.9379 27.613 23.9067 27.2877 23.087 26.7315ZM30.3708 22.3064C30.3708 19.9012 28.4051 17.9355 25.9999 17.9355C23.5947 17.9355 21.629 19.9012 21.629 22.3064C21.629 24.7117 23.5947 26.6773 25.9999 26.6773C28.4051 26.6773 30.3708 24.7117 30.3708 22.3064Z",
    fill: "#1A202C",
    stroke: "#1A202C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsUserAvatar);
export default __webpack_public_path__ + "static/media/DSUserAvatar.09f357195c1424a1bd01510e25971168.svg";
export { ForwardRef as ReactComponent };